import { Link } from 'react-router-dom';

const models = [
  {
    icon: 'ri-medal-line',
    color: 'from-teal-500 to-emerald-500',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
    badge: 'Maximale Flexibilität',
    badgeBg: 'bg-teal-100 text-teal-700',
    title: 'White-Label',
    desc: 'Learnsnap komplett unter Ihrer eigenen Marke – eigene Domain, eigenes Branding, eigene Preisgestaltung.',
  },
  {
    icon: 'ri-store-2-line',
    color: 'from-orange-500 to-amber-500',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    badge: 'Maximale Reichweite',
    badgeBg: 'bg-orange-100 text-orange-700',
    title: 'Franchise',
    desc: 'Profitieren Sie von der etablierten Marke Learnsnap und vermarkten als Franchise-Partner mit eigenem Territorium.',
  },
  {
    icon: 'ri-team-line',
    color: 'from-violet-500 to-purple-500',
    bg: 'bg-violet-50',
    border: 'border-violet-200',
    badge: 'Einfacher Einstieg',
    badgeBg: 'bg-violet-100 text-violet-700',
    title: 'Partner',
    desc: 'Der schnellste Einstieg: Nutzen Sie Learnsnap für Ihre Schüler & Kunden mit attraktiven Partner-Konditionen.',
  },
];

const stats = [
  { icon: 'ri-line-chart-line', value: '+47%', label: 'KI-Bildungsmarkt p.a.' },
  { icon: 'ri-building-line', value: '3 Modelle', label: 'Für jeden Bedarf' },
  { icon: 'ri-time-line', value: '48h', label: 'Antwortzeit' },
];

export default function PartnershipTeaser() {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/57d8803d22bcac062e52ac9d49c0549b.jpg')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/85 via-teal-900/75 to-slate-900/85" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/40 text-orange-300 px-5 py-2.5 rounded-full text-sm font-semibold mb-6 animate-pulse">
            <i className="ri-handshake-line text-lg"></i>
            <span>Wir suchen aktiv Kooperationspartner &amp; White-Label-Lizenznehmer</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-5 leading-tight">
            Learnsnap als<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-emerald-400">
              White-Label oder Franchise
            </span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Bieten Sie Ihren Schülern und Kunden eine eigene KI-gestützte Lernplattform –
            ohne eigene Entwicklungskosten. In wenigen Wochen live, unter Ihrer Marke.
          </p>
        </div>

        {/* Stats Row */}
        <div className="flex flex-wrap items-center justify-center gap-8 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-6 py-4">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-500/30 rounded-xl">
                <i className={`${s.icon} text-teal-300 text-xl`}></i>
              </div>
              <div className="text-left">
                <p className="text-2xl font-bold text-white">{s.value}</p>
                <p className="text-xs text-white/60">{s.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Model Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {models.map((m, i) => (
            <div
              key={i}
              className={`${m.bg} border-2 ${m.border} rounded-2xl p-7 hover:scale-[1.02] transition-all relative overflow-hidden`}
            >
              <div className={`absolute top-4 right-4 text-xs font-semibold px-3 py-1 rounded-full ${m.badgeBg}`}>
                {m.badge}
              </div>
              <div className={`w-14 h-14 bg-gradient-to-br ${m.color} rounded-xl flex items-center justify-center mb-5`}>
                <i className={`${m.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{m.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>

        {/* Who it's for */}
        <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 mb-10">
          <div className="flex flex-wrap items-center justify-center gap-6">
            <p className="text-white/70 text-sm font-medium whitespace-nowrap">Ideal für:</p>
            {[
              { icon: 'ri-building-line', label: 'Nachhilfeinstitute' },
              { icon: 'ri-user-star-line', label: 'Einzeltutoren & Lehrkräfte' },
              { icon: 'ri-graduation-cap-line', label: 'Privatschulen & Akademien' },
              { icon: 'ri-briefcase-4-line', label: 'Bildungsunternehmer' },
              { icon: 'ri-global-line', label: 'Online-Bildungsanbieter' },
            ].map((tag, i) => (
              <div key={i} className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 border border-white/20">
                <i className={`${tag.icon} text-teal-300`}></i>
                <span className="text-sm text-white font-medium whitespace-nowrap">{tag.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Key Message + CTA */}
        <div className="text-center">
          <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-6 py-4 mb-8">
            <i className="ri-flashlight-line text-orange-400 text-2xl flex-shrink-0"></i>
            <p className="text-white/90 text-sm text-left">
              <strong className="text-white">Kein Millionenbudget nötig:</strong> Einmalige Setup-Gebühr +
              monatliche Support-Gebühr – individuell nach Ihrem Bedarf kalkuliert.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/partnerschaft"
              className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-10 py-4 rounded-xl font-semibold text-base hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-handshake-line mr-2"></i>
              Jetzt Partner werden
            </Link>
            <Link
              to="/partnerschaft#partner-models"
              className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-xl font-semibold text-base hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              Alle Modelle entdecken
            </Link>
          </div>
          <p className="text-white/50 text-sm mt-4">
            Unverbindlich &amp; kostenlos anfragen • Antwort innerhalb 48 Stunden
          </p>
        </div>
      </div>
    </section>
  );
}
